import { CONSTANTS } from '../config/constants';

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('geojson_data')) {
		let map = new mapboxgl.Map({
			container: 'map-geojson',
			style: CONSTANTS.map_style,
			center: CONSTANTS.map_center,
			zoom: 16,
			minZoom: 13,
			maxZoom: 20,
			maxBounds: [
				[-89.6, 42.96],
				[-89.3, 43.2],
			],
			scrollZoom: true,
			pitchWithRotate: false,
			dragRotate: false,
			hash: false,
			trackResize: true,
		});

		let layerId = false;
		let source;

		const geojsonSelect = document.querySelector('#geojson_data select');
		geojsonSelect.addEventListener('change', (e) => {
			const index = e.target.selectedOptions[0].index;

			if (index > 0) {
				if (layerId) {
					map.removeLayer(layerId);
					map.removeSource(source);
				}
				const feature = W.map_objects[index - 1];
				source = 'geojson-' + index + '-source';
				layerId = 'geojson-' + index + '-layer';

				map.addSource(source, {
					type: 'geojson',
					data: feature.geojson,
				});

				map.addLayer(
					{
						id: layerId,
						type: 'fill',
						source: source,
						paint: {
							'fill-color': '#c5050c',
						},
						filter: ['==', '$type', 'Polygon'],
					},
					'uw-labels',
				);

				map.panTo(turf.centroid(feature.geojson).geometry.coordinates);
			} else {
				if (layerId !== 'undefined') {
					map.removeLayer(layerId);
					map.removeSource(source);
					layerId = false;
				}
			}
		});
	}
});
